import "../../../styles/components/_recent-searches.scss";
import axios from "axios";
import Swiper from "swiper";
const { language_switch, is_mobile_device, } = window.tg;
const defaultImageUrl = "https://tvg-newsletter.imgix.net/LS/693/a0ba7520-0455-482b-afbe-b0eedcf52926.png?q=80&auto=compress,format,enhance&w=400&h=288";
let swiperInitialized = false;
initRecentSearches();

function initRecentSearches() {
    const recentSearches = getRecentSearches();
    if (!recentSearches.length) return;

    const recentSearchesContainer = document.getElementById("recent-searches");
    recentSearchesContainer.style.display = "block";
    document.getElementById("recent-searches-row").classList.remove("d-none");

    manageSwiperControls(recentSearches.length);
    getPictures(recentSearches.map((item) => item.permalink))
        .then(( data ) => {
            let imageURLs = data.results;
            populateSwiper(imageURLs, recentSearches);
            initSwiper();
        })
        .catch(error => {
            console.error("Error while fetching data:", error)
            recentSearchesContainer.style.display = "none";
        }
        );
};

function isValidDate(date, thresholdDate = new Date().setHours(2, 0, 0, 0)) {
    if (date) {
        const inputDate = new Date(date).setHours(2, 0, 0, 0);
        return inputDate >= thresholdDate;
    }
    return false;
};

function isDateInRange(date, minDate, maxDate) {
    const targetDate = new Date(date).setHours(0, 0, 0, 0);
    const startDate = new Date(minDate).setHours(0, 0, 0, 0);
    const endDate = new Date(maxDate).setHours(0, 0, 0, 0);

    return targetDate >= startDate && targetDate <= endDate;
}

function incrementDateByDays(date, numOfDays) {
    if (date && numOfDays) {
        const newDate = new Date(new Date(date).getTime() + numOfDays * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);
        return newDate
    }
    return false;
};

function populateSwiper(imageURLs, recentSearches) {
    const swiperWrapper = document.getElementById("swiper-wrapper");
    let tempContainer = null;

    // Loop through recentSearches and create a card for each, add to swiper
    recentSearches.forEach((search, index) => {
        if (is_mobile_device) {
            // Every two items or the first item starts a new slide
            if (index % 2 === 0 || tempContainer === null) {
                tempContainer = document.createElement("div");
                tempContainer.classList.add("swiper-slide");
            }
        } else {
            // For non-mobile devices, each item is a new slide
            tempContainer = document.createElement("div");
            tempContainer.classList.add("swiper-slide");
        }

        const recentContainer = document.createElement("div");
        recentContainer.classList = "recent-searches-container mb-3 mb-md-0";

        // If the start date is within the last week
        // let's suggest to the user their search dates +7
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 7));
        if (isValidDate(search.start, sevenDaysAgo) && isDateInRange(search.start, sevenDaysAgo, new Date())) {
            search.start = incrementDateByDays(search.start, 7);
            search.end = incrementDateByDays(search.end, 7);
        }

        const arrowContainer = createArrowElement();
        const imageContainer = createImageElement(imageURLs[search.permalink]);
        const detailsElement = createDetailsElement(search);

        recentContainer.append(
            arrowContainer,
            imageContainer,
            detailsElement
        );

        const recentLink = createSearchLink(search);

        recentLink.appendChild(recentContainer);
        tempContainer.appendChild(recentLink);
        if (
            !is_mobile_device ||
            index % 2 === 1 ||
            index === recentSearches.length - 1
        ) {
            swiperWrapper.appendChild(tempContainer);
            tempContainer = null; // Reset for the next group of two
        }
    });
}

function getRecentSearches() {
    const storageKey = `suggestions_ls_${language_switch || 'en'}`;
    const searchesStorage = JSON.parse(localStorage.getItem(storageKey)) || [];

    const thresholdDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000); // 7 days ago

    return searchesStorage.filter(search => isValidDate(search.updated_at, thresholdDate)).slice(0, 12);
}

function getPictures(initial_params) {
    return axios
        .get("/backend/home/recent-searches", {
            params: initial_params,
        })
        .then(function (response) {
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error("Request failed with response: " + JSON.stringify(data));
            }
        })
        .catch(error => console.error(error));
}

function createArrowElement() {
    const arrowContainer = document.createElement("div");
    arrowContainer.classList = "recent-searches-arrow";

    const icon = document.createElement("i");
    icon.classList.add("far", "fa-arrow-right", "fa-rotate-by", "text-primary");
    icon.style.setProperty("--fa-rotate-angle", "315deg");
    icon.style.color = "#ec772d";

    arrowContainer.appendChild(icon);

    return arrowContainer;
}

function createSearchLink(recent) {
    const { permalink, start, end, allocation, guests } = recent;
    let urlParams = new URLSearchParams();

    if (isValidDate(start) && isValidDate(end)) {
        urlParams.append('start', encodeURIComponent(start));
        urlParams.append('end', encodeURIComponent(end));

        // backwards compatibility for old search objects
        if (guests) {
            urlParams.append('adult', encodeURIComponent(guests.adt));
            urlParams.append('child', encodeURIComponent(0));
            urlParams.append('child_ages', encodeURIComponent([]));
        }

        if (allocation) {
            urlParams.append('adult', encodeURIComponent(allocation.adult));
            urlParams.append('child', encodeURIComponent(allocation.child));
            urlParams.append('child_ages', allocation.child_ages.value.join(','));
        }

    }

    const queryString = urlParams.toString();
    const completeUrl = queryString ? `${permalink}?${queryString}` : permalink;
    const link = document.createElement('a');
    link.href = completeUrl;
    link.style.textDecoration = "none";

    return link;
}

function createImageElement(imageUrl) {
    const img = document.createElement("img");
    img.src = imageUrl || defaultImageUrl;
    img.className = "recent-searches-image";

    return img;
}
function createDateElement(dateStart, dateEnd) {
    const dateElement = document.createElement("p");

    if (isValidDate(dateStart) && isValidDate(dateEnd)) {
        const startDate = new Date(dateStart);
        const endDate = new Date(dateEnd);
        const dateOptions = {
            weekday: "short",
            month: "short",
            day: "numeric",
        };

        const formattedStartDate = startDate.toLocaleDateString(
            language_switch == "af" ? "af-ZA" : "en-US",
            dateOptions
        );
        const formattedEndDate = endDate.toLocaleDateString(
            language_switch == "af" ? "af-ZA" : "en-US",
            dateOptions
        );

        dateElement.textContent = `${formattedStartDate} - ${formattedEndDate}`;
    }

    return dateElement;
}

function createPaxElement(allocation) {
    const paxElement = document.createElement("p");
    paxElement.className = "mb-0";

    if (allocation) {
        paxElement.textContent = _p('user.adults_cap', '%1$s Adult', '%1$s Adults', allocation.adult);
        if (allocation.child > 0) {
            paxElement.textContent += `, ${_p('user.children_cap', '%1$s Child', '%1$s Children', allocation.child)}`;
        }
    }

    return paxElement;
}

function createTitleElement(title) {
    const titleElement = document.createElement("strong");
    titleElement.textContent = title.length >= 20
        ? title.substr(0, 17) + "..."
        : title;

    return titleElement;
}

function createDetailsElement(search) {
    const detailsContainerWrapper = document.createElement("div")
    detailsContainerWrapper.classList.add("d-flex", 'h-100', "flex-column", "justify-content-center")

    const detailsContainer = document.createElement("div");
    detailsContainer.classList = "recent-searches-details";
    detailsContainer.style.height = "72px";

    const titleElement = createTitleElement(search.query);
    const dateElement = createDateElement(search.start, search.end);
    const paxElement = createPaxElement(search.allocation);

    detailsContainerWrapper.append(detailsContainer);
    detailsContainer.append(titleElement, dateElement, paxElement);

    return detailsContainerWrapper;
}

function manageSwiperControls(count) {
    const swiperControls = document.getElementById("swiper-controls");
    if (count > 3) {
        swiperControls.classList.add("d-lg-flex");
    } else {
        swiperControls.classList.remove("d-lg-flex");
    }
}

function initSwiper() {
    const swiperConfig = {
        spaceBetween: 15,
        loop: false,
        slidesPerView: "auto",
        centeredSlides: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        grabCursor: false,
        watchSlidesProgress: true,
        passiveListeners: true,
        shortSwipes: is_mobile_device,
        navigation: {
            nextEl: ".recent-swiper-button-next",
            prevEl: ".recent-swiper-button-prev",
        },
    };

    if (!swiperInitialized) {
        new Swiper(".recent-searches-swiper", Object.assign(swiperConfig));
        swiperInitialized = true;
    }
}
